<template>
  <b-container fluid >
    <b-row class="text-center">
      <b-col md="4" class="col-xs-4 text-center">
        <b-img style="margin-top: 10vh" fluid src="../assets/images/satinal.jpg"/>
      </b-col>
      <b-col md="8" class="col-xs-8 text-center" style="margin-top: 50px">
        <b-col md="10" style="margin-left: 15px;">
        <h2 style="padding-bottom: 30px">Size uygun EYDS Sınav Paketini Seçip Çalışmaya Hemen Başlayın</h2>
        <p style="padding-bottom: 5px">E-YDS simülasyon programlarımızdan 1 ay boyunca faydanalanmak, <strong>Elektronik YDS</strong> öncesinde bol bol özgün soru çözmek ve E-YDS ekranına daha aşina olabilmek için listeden size uygun sınav paketini seçin.Satın alma işlemi ankaradil.com üzerinde yapılacaktır, siz satın alma yapıp tekrar eyds.org a döndüğünüzde sisteminiz otomatik olarak açılmış olacaktır. Satın alma işlemi yaparken kullandığınız e-posta ve şifre ile ankaradil.com ve eyds.org sitelerine giriş yapabilirsiniz.</p>
        <p style="padding-bottom: 60px">Eğer hali hazırda bir paket satın aldıysanız, satın alma yaptığınız eposta ve şifreniz ile <router-link to="/login">  buradan Giriş </router-link>  yaparak sınavlarınıza ulaşabilirsiniz.</p>
        <h3>Hemen Elektronik YDS Paketinizi Seçin </h3>
        <b-table stacked="sm" :outlined="true" :items="denemePaketleri" :fields="fields">
            <template slot="table-caption">
              Satın almış olduğunuz sınavlara, 1 ay boyunca erişebilirsiz.
            </template>
            <template slot="url" slot-scope="row">
              <b-button size="sm" :href="`${row.value}`" variant="success" target="_blank" class="mr-2">
                HEMEN AL
              </b-button>
            </template>
        </b-table>
          <!--<b-table class="d-none d-xs-block d-sm-none" :items="denemePaketleri" :fields="fields">-->
            <!--<template slot="table-caption">-->
              <!--Satın almış olduğunuz sınavlara, 1 ay boyunca erişebilirsiz.-->
            <!--</template>-->
            <!--<template slot="url" slot-scope="row">-->
              <!--<b-button size="sm" :href="`${row.value}`" variant="success" target="_blank" class="mr-2">-->
                <!--HEMEN AL-->
              <!--</b-button>-->
            <!--</template>-->
          <!--</b-table>  class="d-none d-xs-none d-sm-block"-->
      </b-col>
      </b-col>
    </b-row>

  </b-container>
</template>

<script>
import axios from 'axios'
export default {
  name: 'HelloWorld',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      denemePaketleri: [],
      fields: [{ key: 'satilanDenemeAdi', label: 'Paket Adı', variant: 'primary' },
        { key: 'satisAciklamasi', label: 'Açıklama', variant: 'primary' }, { key: 'fiyat', label: 'Fiyat', variant: 'primary' }, { key: 'denemeAdedi', label: 'Paketin İçerdiği Deneme Adedi', variant: 'primary' },
        { key: 'url', label: 'Hemen Al', variant: 'success' } ]
    }
  },
  mounted () {
    axios
      .get(this.$serviceAddress + 'api/v5/geteydspackages')
      .then(response => (this.denemePaketleri = response.data.data))
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/SatinAl.vue